//#region src/bite_log_heartland_event.ts
var BiteLogHeartlandEvent = /* @__PURE__ */ function(BiteLogHeartlandEvent) {
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["None"] = 0] = "None";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["TerminalDisconnected"] = 1] = "TerminalDisconnected";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["UpdateIdleTextError"] = 2] = "UpdateIdleTextError";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["RefundError"] = 4] = "RefundError";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["AuthTransaction"] = 5] = "AuthTransaction";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["AuthTransactionError"] = 6] = "AuthTransactionError";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["SaleTransaction"] = 7] = "SaleTransaction";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["SaleTransactionError"] = 8] = "SaleTransactionError";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["BalanceInquiry"] = 9] = "BalanceInquiry";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["BalanceInquiryError"] = 10] = "BalanceInquiryError";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["TerminalConnected"] = 11] = "TerminalConnected";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["TerminalInitFailed"] = 12] = "TerminalInitFailed";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["SetupDevice"] = 13] = "SetupDevice";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["DeviceResetFailed"] = 14] = "DeviceResetFailed";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["NativeTransaction"] = 15] = "NativeTransaction";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["NativeTransactionError"] = 16] = "NativeTransactionError";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["TransactionLookup"] = 17] = "TransactionLookup";
	BiteLogHeartlandEvent[BiteLogHeartlandEvent["TransactionLookupError"] = 18] = "TransactionLookupError";
	return BiteLogHeartlandEvent;
}(BiteLogHeartlandEvent || {});
//#endregion
export { BiteLogHeartlandEvent };

//# sourceMappingURL=bite_log_heartland_event.js.map